var $f4fc049a97be1f28$exports = {};
const $f4fc049a97be1f28$var$taglines = [
    "Sweet Game Development.",
    "Fruity Games.",
    "A cornucopia of content!",
    "Straight from the vine video games.",
    "Kid tested, mother approved!",
    "Ripe for the playing.",
    "Games you can sink your teeth into!",
    "Certified USDA Organic.",
    "All Juice No Fat.",
    "(And berries too!)",
    "(Yes, that includes corn)",
    "Trans Rights!",
    "Games with Love!",
    "Games as sweet as fruit!",
    "The Fruits of our Labor!",
    "Where Fun and Games Grow on Trees!",
    "Basket full of fun!",
    "Games for fruit :)",
    "Insert Tagline Here.",
    "All fruit, no basket!",
    "I'm here to fruit basket and basket games, and I'm all out of fruit.",
    "We have to go fruit, marty! fruit to the basket!",
    "No, I AM your fruit basket!",
    "Not to be confused with Fruits Basket!",
    "Not to be confused with Fruit on the Loom!",
    "These games are your jam!",
    "127.0.0.1",
    "<a href='https://www.youtube.com/watch?v=dQw4w9WgXcQ'>Click Me :)</a>",
    "Please don't refresh the tagline or I'll stop existing",
    "Makers of such games you don't know as:"
];
document.getElementById("tagline").innerHTML = $f4fc049a97be1f28$var$taglines[Math.floor(Math.random() * $f4fc049a97be1f28$var$taglines.length)];


//# sourceMappingURL=Website.3c674a26.js.map
